export function formatAndShortenMoney(number) {
  try {
    return number <= 100000
      ? number.toFixed(0).replace(/\d(?=(\d{3})+\.)/g, "$&,")
      : Intl.NumberFormat("en", {
          notation: "compact",
          maximumFractionDigits: 0,
        }).format(number);
  } catch {
    return "0";
  }
}
